import { render, staticRenderFns } from "./account.vue?vue&type=template&id=c9af47d0&scoped=true&lang=pug&"
import script from "./account.vue?vue&type=script&lang=ts&"
export * from "./account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9af47d0",
  null
  
)

export default component.exports